import React, { useMemo } from "react";
import { useLocation, useSearchParams } from "react-router-dom";

import "./PremiumCheckoutResult.scss";

import blueCheck from "../../../../static/img/icon-checkmark-full-knockout-lm@3x.png";
import PremiumCheckoutHeader from "./PremiumCheckoutHeader";
import { useAuthContext } from "../../../../hooks/context/AuthContext";
import {
    maskEmailForBanner,
    maskEmailForSyncHint,
    readEmailFromSearch,
} from "./premiumCheckoutConfig";

const openAppDeepLink = () => {
    const url = process.env.REACT_APP_UNIVERSAL_DEEP_LINK;
    if (url) {
        window.location.assign(url);
    } else {
        console.error("Missing REACT_APP_UNIVERSAL_DEEP_LINK");
    }
};

const PremiumCheckoutCongrats: React.FC = () => {
    const [searchParams] = useSearchParams();
    const location = useLocation();
    const { email: acctEmail, maskedEmailAddress } = useAuthContext();
    const stateEmail =
        (location.state as { email?: string } | null)?.email ?? null;

    const rawEmail = useMemo(() => {
        return (
            readEmailFromSearch(searchParams) ||
            stateEmail ||
            acctEmail ||
            null
        );
    }, [searchParams, stateEmail, acctEmail]);

    const emailDisplay = rawEmail ? maskEmailForBanner(rawEmail) : "";
    const syncEmail = rawEmail
        ? maskEmailForSyncHint(rawEmail)
        : maskedEmailAddress || "";

    return (
        <section
            className="PremiumCheckoutResult"
            aria-label="Checkout success"
        >
            <PremiumCheckoutHeader emailDisplay={emailDisplay} />

            <div className="PremiumCheckoutResult__content">
                <img
                    src={blueCheck}
                    loading="lazy"
                    alt=""
                    className="PremiumCheckoutResult__check"
                />

                <h1 className="PremiumCheckoutResult__title">Congrats!</h1>
                <p className="PremiumCheckoutResult__message">
                    Your Premium benefits are now available.
                </p>

                <button
                    className="PremiumCheckoutResult__cta"
                    type="button"
                    onClick={openAppDeepLink}
                >
                    Open Instant Heart Rate
                </button>

                <div className="PremiumCheckoutResult__help">
                    <h2 className="PremiumCheckoutResult__helpTitle">
                        Not seeing your Premium benefits?
                    </h2>
                    <p>Make sure you&apos;re logged in as:</p>
                    {syncEmail ? (
                        <p className="PremiumCheckoutResult__syncEmail">
                            {syncEmail}
                        </p>
                    ) : null}
                    <p>and then go to:</p>
                    <p className="PremiumCheckoutResult__syncPath">
                        <i>More Tab &gt; Account &gt; Sync Purchases</i>
                    </p>
                </div>
            </div>
        </section>
    );
};

export default PremiumCheckoutCongrats;
